import styled from 'styled-components'
import { Colors } from '~/styles'

const PaginationContainer = styled.div`
  width: 100%;
  bottom: 0;
  display: flex;
  padding: 24px;
  position: fixed;
  align-items: center;
  justify-content: space-between;
`

const PaginationButton = styled.button`
  border: none;
  margin: 0;
  padding: 0;
  width: 60px;
  height: 60px;
  cursor: pointer;
  box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  background-color: transparent;

  &:disabled {
    cursor: not-allowed;
  }

  &:disabled:hover {
    background-color: transparent;
  }

  &:hover {
    background-color: ${Colors.tealBlue};
  }
`

const PaginationIndicatorContainer = styled.div`
  gap: 8px;
  padding: 8px;
  height: 32px;
  display: flex;
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  background-color: ${Colors.lightSilver};
  transition: opacity 0.3s ease, transform 0.3s ease;
  opacity: ${(props) => (props.visible ? 1 : 0)};
  visibility: ${(props) => (props.visible ? 'visible' : 'hidden')};
  transform: translateY(${(props) => (props.visible ? '0' : '4px')});
`

const PaginationIndicator = styled.span`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${(props) => props.active ? Colors.tealBlue : Colors.softGrey};
`

export default {
  PaginationButton,
  PaginationContainer,
  PaginationIndicator,
  PaginationIndicatorContainer,
}